import { Collapse } from "antd";
import * as React from "react";
import { ZSpecCommon, zSpecCommon } from "src/business/specification";
import { columnDisplayId } from "src/business/sysData/sysColumns";
import { BlankLink } from "src/components/BlankLink/BlankLink";
import { MdmTable } from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

type PropsAttrPrimarySpec = {
  value: unknown;
};

export const AttrPrimarySpec: React.FC<PropsAttrPrimarySpec> = (props) => {
  const { value } = props;
  const datasrc = React.useMemo(() => {
    const parsed = zSpecCommon.safeParse(value);
    if (!parsed.success) return [];
    return [parsed.data];
  }, [value]);

  const tableStore = React.useMemo(
    () =>
      new RtStore<ZSpecCommon, {}>({
        rowKey: "id",
        loader: async () => ({
          rows: datasrc,
          totalRows: datasrc.length,
        }),
      }),
    [datasrc],
  );

  return (
    <Collapse
      defaultActiveKey={["primarySpec"]}
      style={{
        margin: "0 16px",
      }}
      items={[
        {
          key: "primarySpec",
          label: "Первичная спецификация",
          styles: {
            body: {
              padding: 4,
            },
          },
          children: (
            <MdmTable
              store={tableStore}
              columns={columns}
              resizableColumns
              components={{ Footer: () => null }}
            />
          ),
        },
      ]}
    />
  );
};

const columns: RtColumn<ZSpecCommon>[] = [
  columnDisplayId,
  {
    key: "name",
    title: "Системное название",
    render: (row) => (
      <BlankLink href={makeUrl(PageUrl.managementPrimSpecCard, { id: row.id })}>
        {row.name}
      </BlankLink>
    ),
  },
  {
    key: "displayName",
    title: "Название",
    render: (row) => row.displayName,
  },
  {
    key: "description",
    title: "Описание",
    render: (row) => row.description ?? "-",
  },
];
